/**
 *
 * UserPageRouter
 *
 */
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { UserPage } from 'app/pages/UserPage';
import { UserPageManager, userPageActions } from 'app/pages/UserPage/slice';
import { withManagers } from 'utils/withManagers';
import { SubscriptionDetailPageManager } from 'app/pages/SubscriptionDetailPage/slice';

export const UserPageRouter = () => {
  const dispatch = useDispatch();

  React.useEffect(() => {
    return () => {
      // Cleanup when component unmounts
      dispatch(userPageActions.cleanup());
    };
  }, [dispatch]);

  return <UserPage />;
};

export default withManagers(
  UserPageManager,
  SubscriptionDetailPageManager,
)(UserPageRouter);
